module.exports = __webpack_public_path__ + "img/cy.96d64ed8.svg";